/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

 import React, { Component } from 'react'
 import { Input, Form, Dropdown, Icon, Popup } from 'semantic-ui-react'
 import {propsAreEqual_NoRerenderNeeded} from '../reducer/util'
 
 const normalizeDisplayValue = (value) =>
   value === '_BLANK_' || value == '-999' ? '' : value;

 export class SelecTextField extends Component {
   constructor() {
     super()
     this.state = {}
   }
   getRubberBindFieldKey = () =>
     `${this.props.inputName || this.props.id || ''}${this.props.shipmentId ?? ''}`;

   isRubberBindForField = (props) =>
     props.fieldName === this.getRubberBindFieldKey();

   componentWillReceiveProps(nextProps) {
     const rubberBind = this.isRubberBindForField(nextProps);
     const valueChanged = nextProps.newValue !== this.state.newValue;
     const counterChanged = nextProps.rbCounterID !== this.state.rbCounterID;

     if (!valueChanged && !counterChanged) return;

     // Not this field — sync tracking only (avoid setState / re-render on sibling binds)
     if (!rubberBind) {
       this.state.newValue = nextProps.newValue;
       this.state.rbCounterID = nextProps.rbCounterID;
       return;
     }

     const nextLocalState = {
       newValue: nextProps.newValue,
       rbCounterID: nextProps.rbCounterID,
     };

     if (nextProps.newValue != null) {
       nextLocalState.focusValueX = normalizeDisplayValue(nextProps.newValue);
       nextLocalState.isFocused = true;
       nextLocalState.wasChanged = true;
     }

     this.setState(nextLocalState, () => {
       this.props.updateValue(this.state.newValue);
       if (this.props.persistOnBlurOnly) {
         // Persist now; keep wasChanged so MainForm's post-bind refocus
         // does not reset focusValueX from a stale value prop.
         this.invokeParentOnBlur();
       }
     });
   }
   shouldComponentUpdate(nextProps, nextState){
     if(window.slowstate)return true;
     if ((nextState.isFocused || this.state.isFocused) && nextProps.persistOnBlurOnly) {
       if (nextProps.value !== this.props.value) return true;
       if (nextProps.rbCounterID !== this.props.rbCounterID) return true;
       if (
         this.isRubberBindForField(nextProps) &&
         nextProps.newValue !== this.props.newValue
       ) {
         return true;
       }
       if (nextState.focusValueX !== this.state.focusValueX) return true;
       if (nextState.isFocused !== this.state.isFocused) return true;
       if (nextState.wasChanged !== this.state.wasChanged) return true;
       if (nextProps.disabled !== this.props.disabled) return true;
       if (nextProps.errors !== this.props.errors) return true;
       if (nextState.dropdownIsFocused !== this.state.dropdownIsFocused) return true;
       if (nextState.littleSearchBox !== this.state.littleSearchBox) return true;
       if (nextState.highlightChanging !== this.state.highlightChanging) return true;
       return false;
     }
     return !propsAreEqual_NoRerenderNeeded(this.props,nextProps) || !propsAreEqual_NoRerenderNeeded(this.state,nextState);
   }
 
   // Detemine value to be saved from item selcted
   getValueToSave = (item) => {
     // If item has id, use that
     if (item.id) {
       // Handle null case
       if (item.id === 'NONE') {
         return '_BLANK_'
       } else {
         return item.id
       }
     } else if (item.stringVal) { // if there is stringVal, use that
       return item.stringVal
     }
     return item
   }

   /** Quantity string for parent onBlur — never pass SyntheticEvent (causes NaN in parseFloat). */
   getBlurQuantityValue = () => {
     const { value, persistOnBlurOnly } = this.props;
     const { isFocused, wasChanged, focusValueX } = this.state;
     const normalizedPropValue = normalizeDisplayValue(value);
     if (persistOnBlurOnly && isFocused && wasChanged && focusValueX != null) {
       return normalizeDisplayValue(focusValueX);
     }
     return normalizedPropValue;
   }

   invokeParentOnBlur = () => {
     const { onBlur } = this.props;
     if (!onBlur) return;
     onBlur(this.getBlurQuantityValue());
   }
 
   errorPopup = (errors, label, iconColor = 'red') => {
     if(!errors){
       return <label size='small'> {label}</label>;
     }else if(!errors.length){
       return <label size='small'> {label}</label>;
     }
     const error = errors.map((info, index) => {
       return (
         <div className='error' key={index}>
           * {info}
         </div>
       )
     })
     return (
       <label size='small' style={{"width": "auto"}}>
         <Popup 
           trigger={<Icon 
           name='warning sign'
           color={iconColor} 
           />} 
           content={error || ''}
         />
         <span style={{"width": "auto", "overflow": "ellipsis"}} title={label}>
           {label}</span>
       </label>
     )
   }
 
   render() {
     const {
       options,
       inputName,
       iconPosition,
       label,
       width,
       className,
       type,
       icon,
       subLabelClass,
       value,
       dropDownValue,
       updateValue,
       updateDropDownValue,
       onBlur,
       setINPUTID,
       penClicked,
       isInteger,
       handleFocus,
       disabled,
       merchandiseId,
       shipmentId,
       shortSelectText,
       divClassName,
       selectName,
       dropdownDirectionParam='left',
       errors,
       warnings,
       id,
       saveOnTabOut,
       persistOnBlurOnly,
      disableSearchHeaderSelection,
      commitHighlightOnEnter,
       formatWhileTyping,
     } = this.props

     let { littleSearchBox,
      indexOffSet,
      highlightChanging,
      isFocused,
      wasChanged,
      focusValueX,
     }= this.state;
     let redBgColor = "";
    if(errors && errors.length){
      redBgColor = "redBgColor";
    }
    const hasWarnings = warnings && warnings.length;
    const labelMsgs = (errors && errors.length) ? errors : (hasWarnings ? warnings : errors);
    const labelIconColor = (errors && errors.length) ? 'red' : 'yellow';
    let inputFieldId = id+merchandiseId+inputName + shipmentId;
     let newLabel = this.errorPopup(labelMsgs, label, labelIconColor);
     let subLabelText = true
     let stringsAreEqual = (str1,str2)=>{
       return (str1+"").toLowerCase()===(str2+"").toLowerCase();
     }
     let data = options === undefined ? [1, 2] : options
     let littleSearchBoxData = data.filter(aaa => {
       if (!littleSearchBox) return true;
       if (typeof aaa === "string" && stringsAreEqual(aaa, littleSearchBox)) return true
       return JSON.stringify(Object.values(aaa || {})).toLowerCase().includes(littleSearchBox.toLowerCase())
     });
     let exactMatches = data.filter(aaaa => {
       if (!littleSearchBox) return false;
       if (typeof aaaa === "string" && stringsAreEqual(aaaa, littleSearchBox)) return true
       return stringsAreEqual(aaaa.id, littleSearchBox) || stringsAreEqual(aaaa.value, littleSearchBox);
     });

     let goldSelectedIndex = -1;
     littleSearchBoxData.map((item, index) => {
                 
      if((typeof item == "string"?stringsAreEqual(item,littleSearchBox):stringsAreEqual(item.id,littleSearchBox))
        
      || littleSearchBoxData.length==1)goldSelectedIndex=index;
     });

     let checkedIndexXX = indexOffSet + goldSelectedIndex
     while(checkedIndexXX < 0)checkedIndexXX= (littleSearchBoxData.length || 1) + checkedIndexXX;

     const normalizedPropValue = normalizeDisplayValue(value);
     const displayValue =
       persistOnBlurOnly && isFocused && wasChanged && focusValueX != null
         ? normalizeDisplayValue(focusValueX)
         : normalizedPropValue;

     const flushQuantityValue = (nextValue) => {
       if (isInteger && !nextValue) {
         updateValue((0).toFixed(2));
       } else {
         updateValue(nextValue);
       }
     };

     return (
       <div
         className={`feildSelect selecTextField ${divClassName || ''} ${
           disabled ? 'disabled' : ''
           } ${redBgColor}
           ${shortSelectText?'shortSelectText':''}
           `}
         style={hasWarnings && !redBgColor ? { backgroundColor: '#fdffbc' } : undefined}
       > 
       {newLabel}
         <Form.Field
           width={width}
           className={highlightChanging?"glowing-text":""}
           style={{ bottom: '0px', position: 'absolute', width: '100%' }}
         >
          
           <Input
             value={displayValue}
             iconPosition={iconPosition}
             id={`${inputName || id || ''}${shipmentId ?? ''}`}
             name={`${inputName || id || ''}${shipmentId ?? ''}`}
             type={type}
             onMouseDown={e => {
              if(disabled)return;
              this.setState({lastFocusxx: Date.now()});
               e.stopPropagation()
               penClicked && penClicked(e)
               this.setState({currentValueRerenderer:Date.now()})
               this.setState({lastKeyDown: null})
             }}
             onFocus={event => {
              if(disabled)return;
               const normalizedFocusValue = normalizeDisplayValue(value);
               this.setState({lastFocusxx: Date.now()});
               handleFocus && handleFocus(event)
               setINPUTID && setINPUTID(`${inputName || id || ''}${shipmentId ?? ''}`)
               const keepLocalValue =
                 persistOnBlurOnly &&
                 this.state.wasChanged &&
                 this.state.focusValueX != null;
               if (
                 !keepLocalValue &&
                 this.state.focusInited &&
                 this.state.focusValueX != normalizedFocusValue
               ) {
                 this.setState({ wasChanged:true });
               }
               this.setState({
                focusValueX: keepLocalValue
                  ? this.state.focusValueX
                  : normalizedFocusValue,
                focusInited: true,
                isFocused: true,
                currentValueRerenderer:Date.now(),
                dropdownIsFocused: false,
                lastKeyDown: null
              })
             }}
             onKeyDown={(event)=>{
              this.setState({lastKeyDown: event.keyCode})
            }}
             onKeyPress={(e)=>{
              if(disabled)return;
                if(e.which == 13){
                    e.preventDefault()
                    e.stopPropagation()
                    return false;
                  }
                if (!persistOnBlurOnly) {
                  this.setState({wasChanged:true, currentValueRerenderer:Date.now()});
                }
              }
             }
             onChange={event => {
              let nextValue = event.target.value;
              if (formatWhileTyping) {
                nextValue = formatWhileTyping(nextValue);
              }
              if (persistOnBlurOnly) {
                this.setState({
                  focusValueX: nextValue,
                  isFocused: true,
                  wasChanged: true,
                });
                return;
              }
              this.setState({wasChanged:true});
               updateValue(nextValue)
               this.setState({currentValueRerenderer:Date.now()})
             }}
             disabled={disabled}
             onBlur={event => {
               let nextValue = event.target.value;
               if (formatWhileTyping) {
                 nextValue = formatWhileTyping(nextValue);
               }
               if(this.props.ignoreTabOnInputField && this.state.lastKeyDown == 9/*tab*/){
                 if (persistOnBlurOnly && this.state.wasChanged) {
                   flushQuantityValue(nextValue);
                 }
                 onBlur && onBlur(nextValue);
                 this.setState({ isFocused: false, focusValueX: nextValue, wasChanged: false });
                 return;
               }
               if(!this.state.wasChanged && !this.props.disableWasChanged)return;
               
              if(disabled)return;
               if (persistOnBlurOnly) {
                 if (this.state.wasChanged || saveOnTabOut || normalizedPropValue != nextValue) {
                   flushQuantityValue(nextValue);
                 }
                 onBlur && onBlur(nextValue);
                 this.setState({ isFocused: false, focusValueX: nextValue, wasChanged: false });
                 setTimeout(()=>{
                  document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();
                 },2000);
                 return;
               }
               if (isInteger && !event.target.value) {
                 updateValue((0).toFixed(2))
               }
               onBlur(event.target.value)
               this.setState({wasChanged:false});
               setTimeout(()=>{
                document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();
               },2000);
             }}
           >
             <input
               className={className + ' form-control fix-border-bottom'}
             />
             {icon}
             {subLabelText && <p className={subLabelClass}>{subLabelText}</p>}
           </Input>

           {((this.state.dropdownIsFocused && this.state.lastFocusxx+5000>Date.now()) || this.state.mouseOverDropdown) && !disabled ? 


           <Dropdown
             lazyLoad={true}
             text={dropDownValue === '_BLANK_' ? 'NONE' : dropDownValue}
             inline
             scrolling
             className="selecTextFieldDropdown"
             style={{display:'flex'}}
             open={!disabled && ((this.state.dropdownIsClicked||0) + 200 < Date.now())}
             onBlur={(eeee)=>{
              this.setState({lastKeyDown: null})
              if(disabled)return;
              this.setState({dropdownIsFocused: false});
              this.setState({highlightChanging:true});
              setTimeout(()=>{
               this.setState({highlightChanging:false});  
               },500);
               if (!this.props.blockOnBlur) this.invokeParentOnBlur()}}
             upward={false}
             disabled={disabled || (!data || data.length<1)}
             onMouseOver={()=>{this.setState({mouseOverDropdown:true})}}
             onMouseOut={()=>{this.setState({mouseOverDropdown:false})}}
             onClick={() => {
              if(disabled)return;
              document.getElementById(inputFieldId) && document.getElementById(inputFieldId).focus()
              this.setState({lastFocusxx: Date.now(), dropdownIsFocused: true, littleSearchBox:""});
             }}
             onFocus={() => {
              this.setState({lastFocusxx: Date.now(), dropdownIsFocused: true});
               document.getElementsByClassName('active-label')[0] &&
                 document.getElementsByClassName('active-label')[0].classList.remove('active-label')
             }}
           >
             <Dropdown.Menu direction={dropdownDirectionParam} id={selectName + shipmentId}>
                <Dropdown.Item
                  text={littleSearchBox||<span style={{opacity:'0.3'}}>...Search</span>}
                  onMouseDown={(e) => {
                    if (!disableSearchHeaderSelection) return;
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onClick={(e) => {
                    if (!disableSearchHeaderSelection) return;
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                />
               {((this.state.lastFocusxx||0)+120000 > Date.now())?littleSearchBoxData.map((item, index) => {
                 
                 return (
                 <Dropdown.Item
                   key={index}
                   onMouseOver={()=>{this.setState({mouseOverDropdown:true})}}
                   onMouseOut={()=>{this.setState({mouseOverDropdown:false})}}
                   style={goldSelectedIndex==index?{backgroundColor:'gold'}:{}}
                   text={
                    ((indexOffSet && (checkedIndexXX == index))?'✔ ':'  ')+
                     (item.id ? item.id : item.stringVal ? item.stringVal : item) + 
                     (item.description?` - ${item.description} `:'')
                   }
                   onClick={(eeee) => {
                    if(disabled)return;
                     updateDropDownValue(this.getValueToSave(item))
                     this.setState({currentValueRerenderer:Date.now(),dropdownIsClicked:Date.now()})
                     // fix: text field's onBlur was getting triggered upon selecting dropdown option
                     {!this?.props?.blockOnBlur && this.invokeParentOnBlur()}
                    setTimeout(()=>{
                      this.setState({lastFocusxx:Date.now()-10000});
                    },50)
                    this.setState({highlightChanging:true});
                    setTimeout(()=>{
                     this.setState({highlightChanging:false});
                     },500);
                   }}
                 />
               )}):[]}
             </Dropdown.Menu>
           </Dropdown>:
           
             <div className="ui active visible inline scrolling dropdown"
             style={{display:'flex'}}
               onClick={() => {
                this.setState({lastFocusxx: Date.now(), dropdownIsFocused: true, littleSearchBox:""});
                setTimeout(()=>{
                  if(disabled)return;
                  document.getElementById(inputFieldId) && document.getElementById(inputFieldId).focus()
                },5)
              }}>
               <div className="divider text">
               {dropDownValue === '_BLANK_' ? 'NONE' : dropDownValue}
               </div>
               <i  className="dropdown icon"></i>
             </div>
           }
           <input style={{width:'1px',height:'1px',padding:'0px', border: '0px',float:'right'}} 
             id={inputFieldId}
             onFocus={() => {
              if(disabled)return;
               this.setState({
                 lastFocusxx: Date.now(),
                 dropdownIsFocused: true,
                 littleSearchBox: ""
               });
             }}
             value={littleSearchBox}
             onKeyDown={eeee =>{
              if(disabled)return;
               if(eeee.code =="ArrowDown"){
                this.setState({indexOffSet:(indexOffSet || 0)+1, lastFocusxx: Date.now()});

               } else if(eeee.code =="ArrowUp"){
                this.setState({indexOffSet:(indexOffSet || 0)-1
                  , lastFocusxx: Date.now()});
               } else  if(eeee.code =="Enter"){
                if (commitHighlightOnEnter) {
                  eeee.preventDefault();
                  const hasTick = !!indexOffSet;
                  const hasGold = goldSelectedIndex >= 0;
                  if (!hasTick && !hasGold) return;
                  const selectedIndex = hasTick ? checkedIndexXX : goldSelectedIndex;
                  const selectedItem = littleSearchBoxData[selectedIndex];
                  if (!selectedItem) return;
                  updateDropDownValue(this.getValueToSave(selectedItem));
                  this.setState({
                    currentValueRerenderer: Date.now(),
                    dropdownIsClicked: Date.now(),
                    dropdownIsFocused: false,
                    littleSearchBox: "",
                    indexOffSet: 0,
                    highlightChanging: true,
                  });
                  if (!this.props.blockOnBlur) this.invokeParentOnBlur();
                  setTimeout(() => {
                    this.setState({ lastFocusxx: Date.now() - 10000 });
                  }, 50);
                  setTimeout(() => {
                    this.setState({ highlightChanging: false });
                  }, 500);
                  return;
                }
                this.setState({
                  littleSearchBox:littleSearchBoxData[checkedIndexXX]?.value || littleSearchBoxData[checkedIndexXX]?.id || littleSearchBoxData[checkedIndexXX] ,
                  indexOffSet:0, 
                  lastFocusxx: Date.now()
                })
                this.setState({highlightChanging:true});
                setTimeout(()=>{
                 this.setState({highlightChanging:false});
                 },500);
                 
               } else {
                this.setState({
                  indexOffSet:0, 
                  lastFocusxx: Date.now()});

               }

             }}
             onChange={(eeee) => {
              if(disabled)return;
                this.setState({
                  littleSearchBox:eeee.target.value,
                  dropdownIsFocused:true,
                  indexOffSet:0, 
                  lastFocusxx: Date.now(),
                  mouseOverDropdown: false
                })
               }}
               onBlur={(eeee)=>{
                if(disabled)return;
                 // Clicking a menu item blurs search first; let onClick own the commit
                 if (this.state.mouseOverDropdown) {
                   this.setState({currentValueRerenderer:0, dropdownIsFocused:false})
                   return;
                 }
                if (disableSearchHeaderSelection) {
                  this.setState({currentValueRerenderer:0, dropdownIsFocused:false})
                  return;
                }
                 if((littleSearchBoxData||[]).length==1){
                  updateDropDownValue(this.getValueToSave(littleSearchBoxData[0]))
                  if (!this.props.blockOnBlur) this.invokeParentOnBlur()
                 } else if(exactMatches.length == 1 && littleSearchBox){
                  updateDropDownValue(this.getValueToSave(exactMatches[0]))
                  if (!this.props.blockOnBlur) this.invokeParentOnBlur()
                 } else if(this.props.ignoreTabOnInputField && this.state.wasChanged){
                   if (!this.props.blockOnBlur) this.invokeParentOnBlur();
                   this.setState({wasChanged:false});
                 }
                this.setState({currentValueRerenderer:0, dropdownIsFocused:false})
               }}
               />
         </Form.Field>
       </div>
     )
   }
 }
 
 export default SelecTextField
 